/* eslint-disable react/function-component-definition */
import React from 'react';
import cn from "../../../utils/cn";
import PropTypes from 'prop-types';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const BaseCardHeader = _ref => {
  let {
    children,
    className,
    id,
    title,
    noBorder = false,
    secondaryFullWidth = false
  } = _ref;
  const headerClass = cn({
    'bg-white rounded-t': true,
    'border-solid border-b border-medium-border-blue': !noBorder
  }, className);
  const mappedChildren = React.Children.map(children, (child, index) => /*#__PURE__*/_jsx("div", {
    className: cn({
      'flex-grow': secondaryFullWidth
    }, 'relative', 'flex-none', 'ml-3'),
    children: child
  }, index));
  return /*#__PURE__*/_jsx("div", {
    ...(id ? {
      id
    } : {}),
    ...(id ? {
      'data-testid': id
    } : {}),
    className: headerClass,
    children: /*#__PURE__*/_jsxs("div", {
      className: "flex flex-row justify-between",
      children: [/*#__PURE__*/_jsx("div", {
        className: "flex-auto p-4 pb-3",
        children: title
      }), /*#__PURE__*/_jsx("div", {
        className: "flex-auto py-2 pr-4 pl-0 flex flex-row justify-end items-center",
        children: mappedChildren
      })]
    })
  });
};
BaseCardHeader.displayName = 'BaseCardHeader';
BaseCardHeader.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  id: PropTypes.string,
  title: PropTypes.string,
  noBorder: PropTypes.bool,
  secondaryFullWidth: PropTypes.bool
};
export default BaseCardHeader;
//# sourceMappingURL=BaseCardHeader.js.map